import prettyBytes from 'filesize'
import { format } from 'date-fns'

export const formatFileSize = fileSize =>
    prettyBytes(fileSize, { standard: 'iec' })

export const formatDate = date => format(new Date(date), 'dd.MM.yyyy')
